
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/it-program",
      function () {
        return require("private-next-pages/it-program.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/it-program"])
      });
    }
  